// External
import moment from "moment";
import _ from "lodash";

// Constants
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";

export const getRatingLogsColumnList = ({ curriculumProgramType }) => {
  return [
    curriculumProgramType == CURRICULUM_TYPE_PYP
      ? {
          id: "course",
          label: "Course",
          hideTooltip: true,
          visible: true,
          alignment: "left",
          type: "TEXTCOLUMN",
          style: { width: "10%" },
        }
      : {
          id: "grade",
          label: "Grade",
          hideTooltip: true,
          visible: true,
          alignment: "left",
          type: "TEXTCOLUMN",
          style: { width: "10%" },
        },
    {
      id: "student",
      label: "Student",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "teacher",
      label: "Teacher",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "subject",
      label: "Subject",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "learningGoal",
      label: "Learning goal",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "criteria",
      label: "Criteria",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "oldRatingValue",
      label: "Previous rating",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "newRatingValue",
      label: "Current rating",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "10%" },
    },
    {
      id: "updatedAt",
      label: "Updated at",
      hideTooltip: true,
      visible: true,
      alignment: "left",
      type: "TEXTCOLUMN",
      style: { width: "20%" },
    },
  ];
};

export const getRatingLogsFeedData = ({ data, curriculumProgramType }) => {
  if (!data || !_.isArray(data)) {
    return [];
  }

  return _.map(data, (item, index) => ({
    id: index,
    ...(curriculumProgramType == CURRICULUM_TYPE_PYP
      ? { course: _.get(item, "courseName", "-") }
      : { grade: _.get(item, "gradeName", "-") }),
    student: _.get(item, "studentName", "-"),
    teacher: _.get(item, "teacherName", "-"),
    subject: _.get(item, "subjectName", "-"),
    learningGoal: _.get(item, "learningGoalLabel", "-"),
    criteria: _.get(item, "criteriaLabel", "-"),
    oldRatingValue: _.get(item, "oldRatingValue", "-"),
    newRatingValue: _.get(item, "newRatingValue", "-"),
    updatedAt: _.get(item, "updatedAt")
      ? moment(_.get(item, "updatedAt")).format("DD MMM YYYY hh:mm A")
      : "-",
  }));
};

export const getRatingLogsQueryInput = ({ data }) => {
  const entityType = _.get(data, "entityType");
  const curriculumProgramId = _.get(data, "curriculumProgramId");

  switch (entityType) {
    case "COURSE_PROGRESS_REPORT_TASK":
      return {
        entityIds: [_.get(data, "courseProgressReportTaskId")],
        entityType,
        curriculumProgramId,
      };
    case "STUDENT_PROGRESS_REPORT":
      return {
        entityIds: [_.get(data, "studentProgressReportId")],
        entityType,
        curriculumProgramId,
        ...(!_.isEmpty(_.get(data, "filters"))
          ? { filters: data.filters }
          : {}),
      };
    case "PROGRESS_REPORT_TASK_GROUP":
    default:
      return {
        entityIds: [_.get(data, "progressReportTaskGroupId")],
        entityType,
        curriculumProgramId,
      };
  }
};
